module.exports = __webpack_public_path__ + "media/images/visit-us-2-276ca913ff2747da99471f9e21bdf4d3.jpg";